import React from 'react'
import rootReducer from '../reducers'
import PropTypes from 'prop-types'
import { GlobalProvider } from 'Shared/global_context'
import configureStore from 'Shared/configure_store'
import OpenRegistrationLayout from './open_registration_layout'

const OpenRegistrationRoot = ({ initialState }) => {
  const { registration_type, addons, metadatas, currency_symbol } = initialState;

  const state = {
    registration_type: registration_type,
    addons: addons,
    metadatas: metadatas || [],
    currency_symbol: currency_symbol,
  }

  const store = configureStore(rootReducer, state, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

  return (
    <GlobalProvider store={store}>
      <OpenRegistrationLayout />
    </GlobalProvider>
  )
}

OpenRegistrationRoot.propTypes = {
  initialState: PropTypes.any,
}

export default OpenRegistrationRoot